import React, { useState, useRef, useEffect, useMemo } from "react"
import { useSpring } from "react-spring"

import { debounce } from "lodash"

import { randomFromString } from "./utils/randomness"

import accentSound from "./assets/bye-audio/bbwexe_sfx.mp3"
import backgroundSound from "./assets/bye-audio/bbwexe_background.mp3"

import { animated } from "react-spring"

import { AMBIENT_VOLUME, ACCENT_VOLUME } from "./config"

import Pizzicato from "pizzicato"

import note01 from "./assets/bye-audio/synth/synth_01.mp3"
import note02 from "./assets/bye-audio/synth/synth_02.mp3"
import note03 from "./assets/bye-audio/synth/synth_03.mp3"
import note04 from "./assets/bye-audio/synth/synth_04.mp3"
import note05 from "./assets/bye-audio/synth/synth_05.mp3"
import note06 from "./assets/bye-audio/synth/synth_06.mp3"
import note07 from "./assets/bye-audio/synth/synth_07.mp3"
import note08 from "./assets/bye-audio/synth/synth_08.mp3"
import note09 from "./assets/bye-audio/synth/synth_09.mp3"
import note10 from "./assets/bye-audio/synth/synth_10.mp3"
import note11 from "./assets/bye-audio/synth/synth_11.mp3"
import note12 from "./assets/bye-audio/synth/synth_12.mp3"
import note13 from "./assets/bye-audio/synth/synth_13.mp3"
import note14 from "./assets/bye-audio/synth/synth_14.mp3"
import note15 from "./assets/bye-audio/synth/synth_15.mp3"
import note16 from "./assets/bye-audio/synth/synth_16.mp3"
import note17 from "./assets/bye-audio/synth/synth_17.mp3"
import note18 from "./assets/bye-audio/synth/synth_18.mp3"
import note19 from "./assets/bye-audio/synth/synth_19.mp3"
import note20 from "./assets/bye-audio/synth/synth_20.mp3"

import { SPEED } from "./config"

const springConfig = {
	mass: 1,
	tension: 84,
	friction: 90,
	clamp: false,
	precision: 0.01,
	velocity: 0,
	duration: undefined,
}

function AccentSound({ volume }) {
	const accentRef = useRef()

	// useEffect(() => {
	// 	accentRef.current.currentTime = 48
	// }, [])

	useEffect(() => {
		accentRef.current.volume = volume
	}, [volume])

	return (
		<audio loop autoPlay ref={accentRef}>
			<source src={accentSound} />
		</audio>
	)
}

function BackgroundSound({ volume }) {
	const bgRef = useRef()

	useEffect(() => {
		bgRef.current.volume = volume
	}, [volume])

	return (
		<audio loop autoPlay ref={bgRef}>
			<source src={backgroundSound} />
		</audio>
	)
}

const AnimatedAccentSound = animated(AccentSound)

let downTimeout

async function loadSounds(onLoad) {
	await fetch(backgroundSound)
	await fetch(accentSound)
	onLoad && onLoad()
}

const percSounds = []

const notes = [
	note01,
	note02,
	note03,
	note04,
	note05,
	note06,
	note07,
	note08,
	note09,
	note10,
	note11,
	note12,
	note13,
	note14,
	note15,
	note16,
	note17,
	note18,
	note19,
	note20,
]

notes.forEach((note) => {
	const sound = new Pizzicato.Sound(note, () => {
		const pan = new Pizzicato.Effects.StereoPanner({
			pan: 0.25 + Math.random() * 0.5,
		})
		sound.addEffect(pan)
		// percSounds.push(sound)
		const play = function (volume) {
			sound.stop()
			sound.volume = volume
			sound.play()
		}
		percSounds.push(debounce(play, 90))
	})
})

export function Sounds({ seed, onLoad, isActive = true }) {
	const [accentVolume, setAccentVolume] = useState(0)
	const [flipFlop, setFlipFlop] = useState(0)

	useEffect(() => {
		loadSounds(onLoad)
	}, [onLoad])

	const rand = useMemo(() => {
		return randomFromString(seed)
	}, [seed])

	useEffect(() => {
		setFlipFlop(flipFlop < 3 ? flipFlop + 1 : 0)
		setAccentVolume(ACCENT_VOLUME)
		if (downTimeout) clearTimeout(downTimeout)
		downTimeout = setTimeout(() => setAccentVolume(0), 500)
		const randomSample = percSounds[Math.floor(rand() * percSounds.length)]

		if (randomSample && isActive && flipFlop === 0) {
			setTimeout(() => {
				randomSample(0.5 + rand() * 0.25)
			}, (rand() * SPEED) / 4)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isActive, rand, seed])

	const animatedVolume = useSpring({
		config: springConfig,
		value: accentVolume,
	})

	return (
		<div className="Sounds">
			{isActive && (
				<>
					<BackgroundSound volume={AMBIENT_VOLUME} />
					<AnimatedAccentSound volume={animatedVolume.value} />
				</>
			)}
		</div>
	)
}
